import React, { useEffect } from "react";
import LogoBlanc from "../components/LogoBlanc";
import "./APropos.css";

const ACTIVITES = [
  { key: "Artiste multimedia", rest: "" },
  { key: "Chercheure", rest: " à l'ECOLAB de l'ESAD Orléans" },
  { key: "Enseignante", rest: " en installation multimedia à l'ESAD Orléans" },
  { key: "Intervenante", rest: " au sein de workshops et d'ateliers, notamment l'atelier Fiction & Mondes multiples — s'abreuver à l'open source" },
  { key: "Compositrice", rest: "" },
  { key: "Prestataire", rest: " — installation audiovisuelle, installation sonore, vidéaste, VJ artist, artiste sonore, conception web, graphisme" },
];

const APropos = () => {




  useEffect(() => {
    document.body.classList.add("page-apropos");
    document.documentElement.classList.add("page-apropos");
    return () => {
      document.body.classList.remove("page-apropos");
      document.documentElement.classList.remove("page-apropos");
    };
  }, []);

  return (
    <>
      <LogoBlanc />
      <div className="ap-root">
        <div className="ap-frame" />
        <h1 className="ap-page-title">À propos</h1>

        {/* ══ SECTION 1 — 4 colonnes dans le cadre ══════ */}
        <section className="ap-s1">

          {/* Colonne 1 — Photo + boutons documents */}
          <div className="ap-col ap-col--photo">
            <div className="ap-portrait">
              <img src="/media/Bio/Elise_Voet_credits_photo_Nino_Lasne.png" alt="Elise Voët" />
            </div>
            <div className="ap-docs-under-photo">
              <div className="ap-doc-group">
                <p className="ap-doc-group-title">Dossier artistique</p>
                <div className="ap-doc-btns">
                  <a href="/media/Bio/EliseVoet_Dossier_artistique_2026.pdf" target="_blank" rel="noreferrer" className="ap-doc-btn">
                    <span className="ap-doc-icon">↗</span><span>Consulter</span>
                  </a>
                  <a href="/media/Bio/EliseVoet_Dossier_artistique_2026.pdf" download className="ap-doc-btn">
                    <span className="ap-doc-icon">↓</span><span>Télécharger</span>
                  </a>
                </div>
              </div>
              <div className="ap-doc-group">
                <p className="ap-doc-group-title">CV</p>
                <div className="ap-doc-btns">
                  <a href="/media/Bio/EliseVoet_CV_Bio_2026.pdf" download className="ap-doc-btn">
                    <span className="ap-doc-icon">↓</span><span>Télécharger</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Colonne 2 — Coordonnées puis Activités en encadrement */}
          <div className="ap-col ap-col--coords">
            <p className="ap-name">Elise Voët</p>
            <div className="ap-identity-details">
              <span>elle / elle</span>
              <span>née à Lille en 1995</span>
              <span>vit et travaille à Orléans et Mer depuis 2024</span>
              <span>bilingue français / anglais</span>
              <a href="mailto:elise.voet@hotmail.fr" className="ap-contact-link">elise.voet@hotmail.fr</a>
              <a href="https://www.instagram.com/_elise_voet_/" target="_blank" rel="noreferrer" className="ap-contact-link">@_elise_voet_</a>
            </div>
            <div className="ap-activites-box">
              <ul className="ap-activites">
                {ACTIVITES.map((a, i) => (
                  <li key={i} className="ap-activite">
                    <span className="ap-activite-marker" />
                    <span className="ap-activite-text">
                      <span className="ap-activite-keyword">{a.key}</span>{a.rest}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Colonne 3+4 — placeholder pour la grid */}
          <div className="ap-col ap-col--empty" />
          <div className="ap-col ap-col--empty" />

        </section>

        {/* Bloc Bio + CV — hors grid, s'étend librement */}
        <div className="ap-bio-block">
          <div className="ap-bio-box">
            <h2 className="ap-col-title">Biographie / Demarche</h2>
            <p><span className="ap-indent" />Elise Voët est artiste chercheure dans le domaine des écosystèmes numériques et du design immersif à l'ECOLAB de l'ESAD Orléans où elle intervient dans des cours d'installation multimédia, des workshops et l'atelier Fiction & Mondes multiples.</p>
            <p>Sa recherche est caractérisée par une approche symbiotique et radiographique de l'étude de phénomènes naturels à travers une hybridation de l'installation vidéo, de l'art sonore, de la performance et de l'art génératif. Compositrice, elle tisse des liens entre l'image et le son, créant des expériences sensibles et immersives guidées par la perception de la matière sonore.</p>
            <p>Ses installations audiovisuelles sont influencées par l'écriture d'anticipation et une préoccupation du déclin de la biodiversité. Elles réagissent avec le monde extérieur en absorbant ses rythmes naturels par le biais de protocoles de spatialisation, data visualization et de temps réel.</p>
            <p><span className="ap-indent" />Partisane de la culture des libertés numériques et du «faire ensemble», elle cultive la transmission de savoir-faire alternatifs dans le champ des arts numériques, l'utilisation d'outils open source, la collaboration et la création contributive.</p>

            <div className="ap-bio-cv-divider" />
            <h2 className="ap-col-title">CV</h2>
            <div className="ap-bio-cv-list">

              <h3 className="ap-cv-sub">Formation</h3>
              <ul className="ap-cv-list">
                <li>2027   -   DSRD / Chercheure de l'Unité de recherche ECOLAB au sein du programme «Edition, Media, Design — Expanded publishing : quand les data deviennent forme», ESAD, Orléans</li>
                <li>2020   -   DNSEP (félicitations du jury), ENSA, Bourges</li>
                <li>2019   -   Cycle 1 de composition électroacoustique, Conservatoire à rayonnement départemental, Bourges</li>
                <li>2018   -   DNA, ENSA, Bourges</li>
              </ul>

              <h3 className="ap-cv-sub">Expositions, diffusions solo/duo</h3>
              <ul className="ap-cv-list">
                <li><span class="italic">Phaínō, Human & Tech 2026,</span> La Labomedia, Musique des vivants, Le 108, Orléans, 2026</li>
                <li>sortie de résidence, Akousthéa, 2026</li>
                <li><span class="italic">An·hydra·n</span>, Le 108, Orléans, 2025</li>
                <li><span class="italic">S'écoule l'air</span>, Chapelle Saint-Mathurin, Ligné, 2024</li>
                <li><span class="italic">Phonèmes</span>, Galerie Poteaux d'Angle, Bourges, 2020</li>
                <li><span class="italic">Laboratorium</span>, festival Festimages, Angoulême, 2016</li>
              </ul>

              <h3 className="ap-cv-sub">Expositions, diffusions collectives</h3>
              <ul className="ap-cv-list">
                <li><span class="italic">Noise — rumeurs et anomalies</span>, ESAD, Orléans, 2026</li>
                <li><span class="italic">SILOPORTEM — Weaving the Heart Machine</span>, festival Matricule Bis, ESAD, Orléans, 2026</li>
                <li><span class="italic">GTA subVersions, Comment ne pas jouer le jeu</span>, festival Matricule Bis, ESAD, Orléans, 2026</li>
                <li><span class="italic">An·hydra·n</span> et <span class="italic">Peuple de Dormance, Antiprisme carré,</span> festival Re/Dé}Connecte, Musique des vivants, La Labomedia, le 108, Orléans, 2025</li>
                <li><span class="italic">Echos du bout du monde</span>, ESAD, Orléans, 2025</li>
                <li><span class="italic">This Person does not exist</span>, ESAD, Orléans, 2025</li>
                <li><span class="italic">An·hydra·n,</span> Vendredi [P]arty#19 Temps Forts, Château Ephémère, Carrières-sous-Poissy, 2023</li>
                <li><span class="italic">Transmutation</span>, Festival des Arts Sonores Zone Libre, Sélection Émergences Sonores, curation par Philippe Franck, Bastia, 2023</li>
                <li><span class="italic">Les artistes nantais soutiennent l'Ukraine</span>, exposition carritative en soutien à la Croix Rouge, le Lieu Unique, Nantes, 2022</li>
                <li><span class="italic">Felicità Goodbye Horses</span>, curation par Mélanie Bouteloup, Poush Manifesto, Paris, 2021</li>
                <li><span class="italic">Transmutation, A little Spectrum</span>, curation par Nin Bevilacqua et Lou Froehlicher, Espace Pita — Play in the Attic, Bourges, 2019</li>
                <li><span class="italic">T.I.N.A., Medium(s)</span>, curation par Mawena Yehouessi, La BOX, Bourges, 2019</li>
                <li>Festival de courts métrages ChalonToutCourt, Chalon-sur-Saône, 2018</li>
                <li>Co-création du festival/diffusion au festival Festimages, Angoulême, 2016</li>
              </ul>

              <h3 className="ap-cv-sub">Performances</h3>
              <ul className="ap-cv-list">
                <li><span class="italic">Phaínō, Human & Tech 2026</span>, La Labomedia, Musique des vivants, Le 108, Orléans, 2026</li>
                <li><span class="italic">Phaínō</span> (version alpha), sortie de résidence, Akousthéa, Orléans, 2026</li>
                <li><span class="italic">Noise — rumeurs et anomalies</span>, ESAD, Orléans, 2026</li>
                <li><span class="italic">Echoes of wisdom</span>, VJ set pour le festival Matricule Bis, DJ sets de Camille Suzanne et Sarah Oulahbib, d'après <span class="italic">SILOPORTEM — Weaving the Heart Machine</span>, festival Matricule Bis, ESAD, Orléans, 2026</li>
                <li>Performances sonores et VJing, la Labomedia, le 108, Orléans, 2025</li>
                <li><span class="italic">An·hydra·n</span>, Vendredi [P]arty#19 Temps Forts, avec Nino Lasne, Château Ephémère, Carrières-sous-Poissy, 2023</li>
                <li>Performances sonores, avec Tifaine Coignoux et Deniz Pire, P9 — Projet Neuf, Saint-Nazaire, 2019</li>
                <li>Performance sonore et VJing, festival Les Électrades, Conservatoire à rayonnement départemental, Bourges, 2018</li>
                <li><span class="italic">T.I.N.A.</span>, avec Chris Aslanian, Aurélia Nardini, Tifaine Coignoux, Gabriel Naghmouchi, <span class="italic">Ondes Sauvages 2 — symbiose et narration cyborg</span>, rAAdio cAArgo, Bourges, 2018</li>
              </ul>

              <h3 className="ap-cv-sub">Résidences artistiques</h3>
              <ul className="ap-cv-list">
                <li>La Labomedia, Musique des Vivants, Human & Tech 2026, Le 108, Orléans, 2026</li>
                <li>Akousthéa, Orléans, 2026</li>
                <li>Vinaigrier d'Orléans, CROUS Orléans, Orléans, 2026</li>
                <li>Arts numériques, arts sonores & nouvelles écritures, Château Éphémère, Carrières-sous-Poissy, 2023</li>
                <li>Felicità Goodbye Horses, Lizières, Épaux-Bézu, Poush Manifesto, Paris, 2020/2021</li>
                <li>Laboratoire de recherche MICA, Université Bordeaux Montaigne, Bordeaux, 2018</li>
              </ul>

              <h3 className="ap-cv-sub">Prix, bourses</h3>
              <ul className="ap-cv-list">
                <li>Lauréate du prix Révélation et de la bourse d'aide à la production Transcultures / Pépinières Européennes de Création, 2023</li>
                <li>Fonds de soutien exceptionnel aux artistes émérites de Nantes, 2022</li>
              </ul>

              <h3 className="ap-cv-sub">Enseignement, interventions</h3>
              <ul className="ap-cv-list">
                <li>workshop <span class="italic">Noise — convergence de signal</span>, ESAD, Orléans, 2026</li>
                <li>cours d'installation multimédia aux 2e et 3e année, ESAD Orléans, 2025/2027</li>
                <li>cours de montage et mixage aux 1e année, ESAD Orléans, 2026/2027</li>
                <li>ateliers de pratiques amateurs <span class="italic">Fiction & Mondes multiples — s'abreuver à l'open source</span>, ESAD, Orléans, 2025/2027</li>
                <li>atelier SITA TouchDesigner, La Labomedia, le 108, Orléans, 2026</li>
                <li>workshop <span class="italic">Noise — rumeurs et anomalies</span>, ESAD, Orléans, 2026</li>
                <li>workshop <span class="italic">SILOPORTEM — Weaving the Heart Machine</span>, ESAD, Orléans, 2026</li>
                <li>workshop <span class="italic">Echos du bout du monde</span>, ESAD, Orléans, 2025</li>
                <li>ateliers <span class="italic">Coding Goûters</span>, Fondation Blaise Pascal, Le Cellier, 2023/2024</li>
                <li>ateliers scolaires d'éveil à l'art numérique, Loire-Atlantique, 2022/2023/2024</li>
                <li>workshops <span class="italic">Open Source</span>, ENSA, Bourges, 2020/2021</li>
                <li>animation des ateliers KidZlab, perte de signal, Montréal, 2019</li>
                <li>ateliers <span class="italic">Tisserandes</span>, maison de retraite ORPEA Le Clos des Bénédictins, CCAS, Halle Saint-Bonnet, Bourges, 2018</li>
                <li>ateliers <span class="italic">Etat de Soi</span>, Foyer Saint-François, Bourges, 2018</li>
              </ul>

              <h3 className="ap-cv-sub">Publications</h3>
              <ul className="ap-cv-list">
                <li><span class="italic">POUSH catalogue</span>, collectif, Editions Dilecta, 2022</li>
                <li><span class="italic">Felicità GOODBYE HORSES</span>, Beaux arts de Paris éditions, Ministère de la culture, ENSA Bourges, 2021</li>
                <li>alternates.to.be, conception d'un site mémoire / recueil participatif de micro-fictions d'anticipation en ligne, 2020</li>
                <li><span class="italic">Les récits alternatifs du monde après que nous ayons été humains</span>, mémoire d'étude écrit sous la direction de Jérôme Joy, alternates.to.be, 2020</li>
                <li><span class="italic">Sô</span> et <span class="italic">Volution</span>, Archipels, curation de Mawena Yehouessi et Vincent Chevillon, archipels.org, 2019</li>
                <li><span class="italic">T.I.N.A.</span>, performances sonores et radiophoniques, rAAdio cAArgo, raadiocaargo.com, 2018</li>
              </ul>

            </div>
            <div className="ap-cv-footer--inline">
              {/* <span>n° de SIRET : 900 501 149 00018</span>
              <a href="https://elisevoet.space" className="ap-cv-link">elisevoet.space</a>
              <a href="mailto:elise.voet@hotmail.fr" className="ap-cv-link">elise.voet@hotmail.fr</a>
              <span>06 70 81 67 45</span> */}
            </div>
          </div>
        </div>

      </div>


    </>
  );
};

export default APropos;